.loading {
  /* display: grid; */
  /* grid-row: content / -1; */
  /* grid-column: content / -1; */
  place-content: center;
  place-self: center;
  margin: auto;
}

.loader {
  display: flex;
  gap: var(--mantine-spacing-md);

  align-items: center;
  /* backdrop-filter: blur(var(--mantine-radius-sm)); */
  /* background: alpha(var(--mantine-color-dark-3), 0.1); */
  padding: var(--mantine-spacing-lg);
  font-size: var(--mantine-font-size-xs);
  font-weight: var(--mantine-heading-font-weight);
  color: var(--mantine-color-dark-2);
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  border-radius: var(--mantine-radius-sm);
}

:global(#root):has(> .loading) {
  position: absolute;
  inset: 0;
  display: grid;
  place-content: center;
}
